import styles from './Features.module.scss'

interface Card {
  skill: [
    ...{
      src: string
      alt: string
      style: number
    }[],
  ]
  title: string
  text: string
}

const cards: Card[] = [
  {
    skill: [
      { src: '/images/LP/frontend/Bootstrap.png', alt: 'Bootstrapロゴ', style: 62 },
      { src: '/images/LP/frontend/MaterialUI.png', alt: 'MaterialUIロゴ', style: 56 },
      { src: '/images/LP/frontend/tailwind-css.png', alt: 'tailwindロゴ', style: 184 },
    ],
    title: 'UIフレームワークで効率化',
    text: 'UIフレームワークを徹底的に活用することで品質の高いサイトを素早く構築することができます。',
  },
  {
    skill: [
      { src: '/images/LP/frontend/atomicDesign.png', alt: 'atomicDesignロゴ', style: 58 },
      { src: '/images/LP/frontend/storyBook.png', alt: 'storyBookロゴ', style: 130 },
    ],
    title: 'コンポーネント開発',
    text: 'Atomic Designに基づきコンポーネントを設計することで再利用性の優れたフロントエンドが構築できます。',
  },
  {
    skill: [
      { src: '/images/LP/frontend/AdobeXD.png', alt: 'AdobeXDロゴ', style: 59 },
      { src: '/images/LP/frontend/figma.png', alt: 'figmaロゴ', style: 110 },
    ],
    title: 'デザインも対応',
    text: '社内にはエンジニアだけでなく、デザイナーチームも在籍しています。日々エンジニアと議論を重ねています。',
  },
  {
    skill: [
      { src: '/images/LP/frontend/Chartjs.png', alt: 'Chartjsロゴ', style: 100 },
      { src: '/images/LP/frontend/Lottie.png', alt: 'Lottieロゴ', style: 88 },
      { src: '/images/LP/frontend/GSAP.png', alt: 'GSAPロゴ', style: 200 },
    ],
    title: 'グラフ/アニメーション',
    text: 'Chart.jsを利用したグラフ描画やアニメーションライブラリを利用したリッチなサイトを構築することができます。',
  },
  {
    skill: [
      { src: '/images/LP/frontend/NextJS.png', alt: 'NextJSロゴ', style: 98 },
      { src: '/images/LP/frontend/AWS.png', alt: 'AWSロゴ', style: 73 },
    ],
    title: 'サーバーサイドレンダリング',
    text: 'SEOやOGPに対応するためのサーバー環境の構築にも対応します。',
  },
  {
    skill: [
      { src: '/images/LP/frontend/GraphQL.png', alt: 'GraphQLロゴ', style: 122 },
      { src: '/images/LP/frontend/webSockets.png', alt: 'webSocketsロゴ', style: 117 },
    ],
    title: 'GraphQL/WebSocket',
    text: 'GraphQLを利用した効率の良い通信やチャットに代表されるWebSocketを利用した双方向通信も実装します。',
  },
]

const Features: React.FC = () => {
  const card = cards.map(({ skill, title, text }) => (
    <li key={title} className={styles.card}>
      <div className={styles.img_wrapper}>
        {skill.map(({ src, alt, style }) => (
          <img key={src} src={src} alt={alt} className={styles.img} style={{ maxWidth: `${style}px` }} />
        ))}
      </div>
      <div className={styles.text_wrapper}>
        <h3 className={styles.card_title}>{title}</h3>
        <p className={styles.card_text}>{text}</p>
      </div>
    </li>
  ))

  return (
    <section className={styles.section} id="features">
      <h2 className={styles.title}>フロントエンド開発を支援します</h2>
      <div className={styles.minitext_wrapper}>
        <p className={styles.minitext}>
          Aitriaでは、UIデザインとフロントエンド開発の双方の考え方を理解したデザイナーとエンジニアがチームを組んでいます。
        </p>
        <p className={styles.minitext}>最新のフロントエンド技術を駆使して、一緒にサイトを開発しましょう。</p>
      </div>
      <div className={styles.card_wrapper}>
        <ul className={styles.ul}>
          <div className={styles.blur}></div>
          {card}
        </ul>
      </div>
    </section>
  )
}

export default Features
